// @flow
import type { ComponentType } from 'react';
import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';

import styles from './threePartResultDummy.css';

import Handle from '../Handle';

const DefaultDragHandle = SortableHandle(() => <Handle />);

type ThreePartResultDummyPropTypes = {
  isSelected?: boolean,
  label?: string,
  title: string,
  rightIndicator?: string,
  hasHandle?: boolean,
  DragHandle?: ComponentType<*>, // CHECK: Tiene que venir wrappeado por SortableHandle,
  onClick?: number => mixed
};

const ThreePartResultDummy = ({
  isSelected = false,
  label = '',
  title = '',
  rightIndicator,
  hasHandle = false,
  DragHandle,
  onClick,
}: ThreePartResultDummyPropTypes) => (
  <div
    className={
    `
      ${styles.threePartResultDummy}
      ${isSelected ? styles.selected : ''}
      ${hasHandle ? styles.hasHandle : ''}
    `
  }
    onClick={onClick}
  >
    {
      hasHandle && (
        typeof DragHandle !== 'undefined'
          ? <DragHandle />
          : <DefaultDragHandle />
      )
    }
    <div className={styles.titleContainer}>
      {
        typeof label !== 'undefined'
          && 
          <div className={styles.label}>
            { label }
          </div>
      }
      <div className={styles.title}>
        { title }
      </div>
    </div>
    {
      typeof rightIndicator !== 'undefined'
        && 
        <div className={styles.rightIndicator}>
          { rightIndicator }
        </div>
    }
  </div>
);

export default ThreePartResultDummy;



// WEBPACK FOOTER //
// ./src/scripts/components/ThreePartResultDummy/index.jsx